import React, { useContext, useEffect, useState } from "react";
import Field from "../core/ui/forms/field";
import SessionContext from "SessionContext";
import { Button } from "reactstrap";
import ConfirmSuccess from "../core/ui/confirm-success";
import UnsavedChanges from "partials/unsaved-changes";

export default function Profile() {
  const session = useContext(SessionContext);

  const [disableSave, setDisableSave] = useState(true);
  const [originalData, setOriginalData] = useState();
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
  });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const getUserData = (user_id) => {
    session
        .query("users/get", { id: user_id })
        .then((response) => {
          setOriginalData(response);
          setUser(response);
        })
        .catch((error) => {
          console.log(JSON.stringify(error));
        });
  }

  useEffect(() => {
    const user_id = session.appState.identity.user.id;
    if(user_id) {
      getUserData(user_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    function checkForEmpty() {
      if(
        user.first_name.length &&
        user.last_name.length
      ) {
        checkForChanges();
      } else {
        setDisableSave(true);
      }
    }

    function checkForChanges() {
      if(
        user.first_name === originalData.first_name &&
        user.last_name === originalData.last_name
      ) {
        setDisableSave(true);
      } else {
        setDisableSave(false);
      }
    }
    
    if(originalData) {
      checkForEmpty();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  function onClickSave(ev) {
    ev.stopPropagation();
    ev.preventDefault();
    setDisableSave(true);
    session.command("users/update", user).then((response) => {
      setUser(response);
      setShowSuccess(true);
      setHasUnsavedChanges(false);
      setTimeout(() => {
        setShowSuccess(false);
        window.location.reload();
      }, 2000);
    });
  }

  function setFirstName(ev) {
    setUser({ ...user, first_name: ev.target.value });
  }

  function setLastName(ev) {
    setUser({ ...user, last_name: ev.target.value });
  }

  useEffect(() => {
    if(disableSave) {
      setHasUnsavedChanges(false);
    } else {
      setHasUnsavedChanges(true);
    }
  }, [disableSave])

  return (
    <form className="page admin-page profile-page" onSubmit={e => e.preventDefault()}>
      <div className="list-header sticky-page-header">
        <h1>User Profile</h1>
      </div>

      <section className="profile-details">
        <div className="profile-buttons">
          <Button className="new-button" onClick={onClickSave} disabled={disableSave}>
            Save Changes
          </Button>
        </div>

        <Field label="*First Name:">
          <input
            type="text"
            value={user.first_name}
            className="profile-details-info"
            onChange={setFirstName}
          />
        </Field>

        <Field label="*Last Name:">
          <input
            type="text"
            value={user.last_name}
            className="profile-details-info"
            onChange={setLastName}
          />
        </Field>

        <Field label="Email:" className="role">
          <span className="profile-details-info">
            {user.email}
          </span>
        </Field>

        <Field label="Role:" className="role">
          <span className="profile-details-info">
            {user.role_name}
          </span>
        </Field>

      </section>
      <UnsavedChanges hasUnsavedChanges={hasUnsavedChanges} />
      <ConfirmSuccess show={showSuccess} label="User Saved successfully." />
    </form>
  );
}
